const sortProducts = (productA, productB) => {
  return sortProductsWithDiscountProperty(productA, productB, false);
};

const sortProductsWithDiscountProperty = (productA, productB, haveDiscountProperty = true) => {
  const productAIsGift = haveDiscountProperty ? productA?.discount?.isGift : productA?.isGift;
  const productBIsGift = haveDiscountProperty ? productB?.discount?.isGift : productB?.isGift;
  if (productAIsGift && !productBIsGift) {
    return -1;
  } else if (!productAIsGift && productBIsGift) {
    return 1;
  }
  return 0;
};

export { sortProductsWithDiscountProperty, sortProducts };
